export default {
	isPopupDisabled: process.env.REACT_APP_HARNESS_DISABLE_POPUPS === "true"
}
